import * as React from 'react';
import {ClientContextClass} from './ClientContextClass';
import type {ClientContextInterface} from './ClientContextInterface';

export const ClientContext = React.createContext<ClientContextInterface>(
  new ClientContextClass(),
);
